export const communityEditModalSelector = state => state.communityModals.get('communityEditModal');
export const communityManageModalSelector = state => state.communityModals.get('communityManageModal');
